import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { GetASDDashPostventas, GroupByForeignKey, GroupByPropCheck } from "../../Finanzas/Actions/GetContainer";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import FechaInput from "../../CreditoyCobranza/ReporteCobranza/Helper/FechaInput";
import { validarRangoFechas } from "../../../Helpers/ValidacionFechas";
import { AnioArray } from "../../../Arrays/AnioArray";

// Filtro modal del dashboard principal (Pantalla 1): Fecha Inicio, Fecha
// Fin, Año, Región y Sucursal. Fecha/Año controlados por `boxState`; Región
// y Sucursal dependen del catálogo real y se relacionan en cascada (ver `selectedClick`).
const FiltroReporteRefacciones = ({
    onExecute,
    boxState,
    onBoxChange,
    cargarfiltros = true,
    mostrarestatus = false,
    mostrarmotivo = false,
    mostrarwhatsapp = false,
    sucursalesEncontrados,
    adrEncontrados,
}) => {

    const [openModal, setOpenModal] = useState(false);
    const [state, setState] = useState({
        linea: 0,
        adr: [],
        sucursal: [],
        whatsapp: 'C',
        estatus: 'CC',
        motivo: 'CC',
        periodo: new Date().getMonth() + 1,
    });
    const {
        data,
        adr,
        sucursal,
        departamento,
    } = state;
    const onOpenModal = () => {
        const container = document.getElementById("mdlFiltros-modal");
        if (!container) return;
        if (openModal) {
            container.style.display = "flex";
            setOpenModal(false);
        } else {
            container.style.display = "none";
            setOpenModal(true);
        }
    };

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    useEffect(() => {
        // onClose();
        if (cargarfiltros)
            GetASDDashPostventas()
                .then((res) => {
                    setState({
                        ...state,
                        data: res,
                    });
                })
                .catch((err) => console.log(err));
    }, []);
    // console.log(state.data)
    useEffect(() => {
        var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
        var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
        var newdepartamento = GroupByPropCheck(
            data,
            ["iddepartamento", "departamento"],
            false
        );

        let sucursalesSI = false
        let sucursalesMarcadas = []
        if (sucursalesEncontrados !== null && sucursalesEncontrados !== undefined && sucursalesEncontrados !== "") {

            sucursalesSI = true

            const sucursalesSeleccionadas = sucursalesEncontrados.split(",").map(idsucursal => Number(idsucursal));

            sucursalesMarcadas = newsucursal.map(item => ({
                ...item,
                checked: sucursalesSeleccionadas.includes(Number(item.idsucursal))
            }));
        }

        let adrSI = false
        let adrMarcados = []
        if (adrEncontrados !== null && adrEncontrados !== undefined && adrEncontrados !== "") {

            adrSI = true

            const adrSeleccionados = adrEncontrados.split(",").map(idadr => Number(idadr));

            adrMarcados = newadr.map(item => ({
                ...item,
                checked: adrSeleccionados.includes(Number(item.idadr))
            }));
        }

        setState({
            ...state,
            adr: adrSI === true ? adrMarcados : newadr,
            sucursal: sucursalesSI === true ? sucursalesMarcadas : newsucursal,
            departamento: newdepartamento,
        });
    }, [data]);

    // Valida el rango y dispara el endpoint del dashboard con `boxState`.
    const onCargar = () => {
        const validacion = validarRangoFechas(boxState.fechaInicio, boxState.fechaFin);
        if (!validacion.ok) {
            Swal.fire("REPORTE REFACCIONES", validacion.mensaje, "warning");
            return;
        }

        onOpenModal();

        if (typeof onExecute !== "function") return;

        // onExecute ya maneja el error; aquí solo se atrapa para no dejar un rechazo sin manejar.
        onExecute(boxState)
            .then(() => { })
            .catch(() => { });
    };

    // `boxState.anio` es un arreglo de años seleccionados (vacío = "Todos").
    const onToggleAnio = (id) => {
        const actual = boxState.anio || [];
        const nuevaSeleccion = actual.includes(id)
            ? actual.filter((valor) => valor !== id)
            : [...actual, id];
        onBoxChange("anio", nuevaSeleccion);
    };

    const labelclick = ({ target }) => {
        target.parentNode.firstChild.click();
    };

    const selectedClick = ({ target }, index) => {
        switch (target.name) {
            case "chk-adr":
                var newarray = adr;
                newarray[index].checked = target.checked;

                var newarrarsucursal = [];
                var newarraydepartamento = [];
                var adrActive = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
                        newarrarsucursal = newarrarsucursal.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "idsucursal",
                                "sucursal",
                            ])
                        );
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                // Al cambiar Región se limpia Sucursal (su listado se recalcula sin marcar).
                onBoxChange("adr", adrActive.map((item) => item.idadr));
                onBoxChange("sucursal", []);
                setState({
                    ...state,
                    adr: newarray,
                    sucursal:
                        newarrarsucursal.length == 0
                            ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
                            : GroupByPropCheck(
                                newarrarsucursal,
                                ["idsucursal", "sucursal"],
                                false
                            ),
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            case "chk-sucursal":
                var newarray = sucursal;
                newarray[index].checked = target.checked;

                var newarraydepartamento = [];
                var sucursalactiva = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        sucursalactiva = [
                            ...sucursalactiva,
                            { idsucursal: item.idsucursal, sucursal: item.sucursal },
                        ];
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("sucursal", sucursalactiva.map((item) => item.idsucursal));
                setState({
                    ...state,
                    sucursal: newarray,
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            default:
                var newarray = departamento;
                var departamentoactivo = [];
                newarray[index].checked = target.checked;

                newarray.forEach((item) => {
                    if (item.checked) {
                        departamentoactivo = [
                            ...departamentoactivo,
                            {
                                iddepartamento: item.iddepartamento,
                                departamento: item.departamento,
                            },
                        ];
                    }
                });
                setState({
                    ...state,
                    departamento: newarray,
                });
                break;
        }
    };

    const onChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };

    const onChangeestatus = (e) => {
        const { name, value } = e.target;

        // Si cambia el estatus y ya no es 'SI', resetea el motivo a 'CC'
        if (name === 'estatus') {
            setState((prev) => ({
                ...prev,
                estatus: value,
                motivo: value === 'SI' ? prev.motivo : 'CC', // solo mantiene motivo si sigue en 'SI'
            }));
        } else {
            setState((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };


    return (
        <div className="filtros-pedidos-facturados">
            <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
                <FilterAltIcon /> Filtrar
            </div>
            <div className="mdl-filtro-resumen-cartera" id="mdlFiltros-modal">
                <PlantillaScreen
                    titulo={`Filtro`}
                    className_main={1}
                    className={"modal-filtro-resumen-cartera-mensual modal-filtro-reporte-refacciones"}
                >
                    <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
                        X
                    </div>
                    <div className="modal-filtro-resumen-cartera-mensual-container">
                        <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
                            <div className="filtro-tiempo-tipo">
                                <div className="filtro-group">
                                    <label>Fecha Inicio</label>
                                    <FechaInput
                                        name="fechaInicio"
                                        value={boxState.fechaInicio}
                                        onChange={onChange}
                                    />
                                    <label>Fecha Fin</label>
                                    <FechaInput
                                        name="fechaFin"
                                        value={boxState.fechaFin}
                                        onChange={onChange}
                                    />
                                </div>

                                <div
                                    className="mdlFiltros-modal-acciones-guardar"
                                    onClick={onCargar}
                                >
                                    Cargar
                                </div>
                            </div>
                            <div className="filtro-anio">
                                <div className="title title-anio">AÑO</div>
                                {AnioArray.map((item) => (
                                    <div key={item.id} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-anio"
                                            onChange={() => onToggleAnio(item.id)}
                                            checked={(boxState.anio || []).includes(item.id)}
                                            value={item.id}
                                        />
                                        <label onClick={() => onToggleAnio(item.id)}>
                                            {item.display}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            <div className="filtro-adr">
                                <div className="title title-adr">REGION</div>
                                {adr.map((item, index) => (
                                    <div key={`${item}-${index}`} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-adr"
                                            onChange={(e) => selectedClick(e, index)}
                                            checked={item.checked}
                                            value={item.idadr}
                                        />
                                        <label>{item.adr}</label>
                                    </div>
                                ))}
                            </div>
                            <div className="filtro-sucursal">
                                <div className="title-sucursal">SUCURSAL</div>
                                {sucursal.map((item, index) => (
                                    <div key={`${item}-${index}`} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-sucursal"
                                            className="my-checkbox"
                                            onChange={(e) => selectedClick(e, index)}
                                            checked={item.checked}
                                            value={item.idsucursal}
                                        />
                                        <label onClick={labelclick}>{capitalizeWords(item.sucursal)}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="mdlFiltros-modal-acciones">
                        </div>
                    </div>
                </PlantillaScreen>
            </div>
        </div>
    );
};

export default FiltroReporteRefacciones;